module.exports = __webpack_public_path__ + "static/media/homepage_atf_1_mo_en.d0a1ed9b.png";